<div class="page page-servicos"> 
  <div class="section-breadcrumbs" *ngIf="itensBreadcrumbs.length > 0"> 
    <breadcrumbs home="false" [itens]="itensBreadcrumbs"></breadcrumbs>
  </div>
  <div *ngIf="response.status == 1"> 
    <div class="page-title" *ngIf="categoria != null">
      <div class="container">
        <h1 class="page-title-h1 center">{{categoria.titulo}}</h1>
        <h2>{{categoria.subtitulo}}</h2>
      </div>  
    </div> 
    <div class="page-title" *ngIf="categoria == null">
      <div class="container">
        <h1 class="page-title-h1 center">Serviços</h1>
      </div>  
    </div> 
    <div class="page-content"> 
      <div class="container"> 
        <section class="section section-page">
          <div class="section produtos" id="produtos">
            <div class="lista-de-produtos" *ngIf="produtos.length > 0">
              <div class="_container">
                <div class="row">
                  <div class="col-lg-4 col-md-6 wow slideInUp" data-wow-delay="0.5s" *ngFor="let item of produtos;let i=index;let last=last;">
                    <produto-item [apelidoCategoria]="apelidoCategoria" [apelidoDestino]="apelidoDestino" classCustom="default-page" [data]="item" [index]="i"></produto-item>
                  </div>  
                </div>  
              </div> 
            </div>
            <div class="empty-produtos" *ngIf="produtos.length == 0">
              <span class="message-default" *ngIf="apelidoCategoria != 'transfers'">Não temos serviços para mostrar.</span>
              <span class="message-default" *ngIf="apelidoCategoria == 'transfers'">Para contratar nosso serviço de transfer, solicitamos entrar em contato através dos nossos telefones fixos, email ou WhatsApp <strong class="whatsapp" (click)="openWhats()">(82) 99137-8394</strong></span>
            </div> 
          </div>
        </section>
      </div>  
    </div> 
    <modulo posicao="whatsapp" template="fixo"></modulo> 
  </div>
  <div *ngIf="response.status == 500">
    <div class="container">  
      <page-error [data]="response.data" (reload)="getData()"></page-error>
    </div>  
  </div>
</div>    
<loader *ngIf="loader"></loader>   
